export const GET_DOCUMENT_THROUGHS = "GET_DOCUMENT_THROUGHS";
export const GET_DOCUMENT_THROUGH = "GET_DOCUMENT_THROUGH";
export const ADD_DOCUMENT_THROUGH = "ADD_DOCUMENT_THROUGH";
export const DELETE_DOCUMENT_THROUGH = "DELETE_DOCUMENT_THROUGH";
export const UPDATE_DOCUMENT_THROUGH = "UPDATE_DOCUMENT_THROUGH";
